export const banners = [
  {
    id: "b1",
    title: "十月生活记录季",
    subtitle: "晒出你的日常片段，和十万个同好一起把日子过成诗",
    tag: "官方精选",
    topicId: "t1",
    image: "https://readdy.ai/api/search-image?query=warm%20autumn%20lifestyle%20flat%20lay%20with%20coffee%20and%20journal%2C%20cream%20and%20amber%20tones%2C%20soft%20natural%20light%2C%20minimal%20clean%20aesthetic%2C%20editorial%20photography&width=1600&height=720&seq=banana-banner-01&orientation=landscape",
  },
  {
    id: "b2",
    title: "专业讨论周 · 架构专场",
    subtitle: "和一线工程师拆解真实系统难题，把踩坑变成经验",
    tag: "专题推荐",
    topicId: "t2",
    image: "https://readdy.ai/api/search-image?query=abstract%20connected%20network%20nodes%20concept%20in%20warm%20amber%20and%20cream%20tones%2C%20minimal%20clean%20background%2C%20editorial%20tech%20illustration&width=1600&height=720&seq=banana-banner-02&orientation=landscape",
  },
  {
    id: "b3",
    title: "一起去远方",
    subtitle: "旅行攻略征集进行中，分享你的路线就能帮到很多人",
    tag: "社区活动",
    topicId: "t3",
    image: "https://readdy.ai/api/search-image?query=golden%20sunset%20over%20winding%20road%20through%20vast%20landscape%2C%20amber%20and%20cream%20tones%2C%20cinematic%20travel%20photography&width=1600&height=720&seq=banana-banner-03&orientation=landscape",
  },
  {
    id: "b4",
    title: "兴趣不打烊",
    subtitle: "露营、绿植、摄影、桌游，找到属于你的同好圈子",
    tag: "热门圈子",
    topicId: "t7",
    image: "https://readdy.ai/api/search-image?query=cozy%20outdoor%20camping%20gathering%20with%20warm%20lanterns%20at%20dusk%2C%20amber%20and%20cream%20tones%2C%20soft%20inviting%20mood%2C%20lifestyle%20photography&width=1600&height=720&seq=banana-banner-04&orientation=landscape",
  },
];